<ng-container *transloco="let t">
  <div
    [class]="
      'page-component' +
      (withMarginTop ? ' page-component-with-margin-top' : '')
    "
  >
    @if(rowSelected){
    <mc-tag appearance="neutral-weak" class="row-selected-tag">
      <div class="row-selected">
        <span>{{ selectedRowLength }} {{ t("accessorial_Selected") }}</span>
      </div>
      <div class="delete-button">
        <span
          (click)="bulkItemSelected()"
          style="cursor: pointer"
          class="delete-label"
          >Delete ({{ selectedRowLength }})</span
        >
      </div>
    </mc-tag>
    } @else {
    <section class="page-component-top">
      @if(topNotification){

      <mc-notification
        class="top-notification-overlay"
        fit="medium "
        class="top-notification-overlay"
        body="{{ topNotificationbody }}"
        appearance="{{ topNotificationAppearance }}"
        (close)="topNotificationClosed()"
        icon="{{ topNotificationTrailingIcon }}"
      >
      </mc-notification>

      }
      <div class="page-component-top-left">
        @if(backButtonClick) {
        <mc-button
          class="page-wrapper-back-button"
          appearance="neutral"
          hiddenlabel=""
          variant="plain"
          width="auto"
          (click)="backButtonClick()"
        >
          <span slot="icon"
            ><mc-icon icon="arrow-left" size="24"></mc-icon
          ></span>
        </mc-button>
        }
        <mc-tooltip
          *ngIf="isTextOverflowing"
          [opendelay]="50"
          appearance="neutral-default"
          [zindex]="99999"
        >
          <h3
            slot="trigger"
            class="page-component-top-title ellipsis"
            #titleElement
          >
            {{ title ?? "" }}
          </h3>
          <span>{{ title ?? "" }}</span>
        </mc-tooltip>
        <h3
          *ngIf="!isTextOverflowing"
          class="page-component-top-title ellipsis"
          #titleElement
        >
          {{ title ?? "" }}
        </h3>
      </div>
      @if(topRightButtonLabel){
      <mc-button
        icon="{{ topRightButtonIcon }}"
        appearance="{{ topRightButtonAppearance }}"
        label="{{ topRightButtonLabel }}"
        (click)="topRightButtonClick()"
      ></mc-button>
      } @if (withTopRightMenuHeader) {
      <mc-menu position="bottom-center">
        <mc-button
          slot="trigger"
          [label]="topRightMenuHeaderLabel"
          appearance="primary"
        ></mc-button>
        <mc-list (listchange)="onTopRightHeaderItemClick($event)">
          @for (item of topRightMenuHeaderOptions; track item) {
          <mc-list-item
            class="custom-padding-list-item"
            [label]="item"
          ></mc-list-item>
          }
        </mc-list>
      </mc-menu>
      }
    </section>
    }
    <section class="page-component-content">
      <ng-content></ng-content>
      @if(storeService.showNotification && !withoutNotifications){
      <mc-notification
        class="mc-notification-top-full"
        [body]="storeService.notificationMessage"
        [appearance]="storeService.notificationType"
        [icon]="storeService.notificationIcon"
        width="100%"
      >
      </mc-notification>
      }
    </section>
  </div>
</ng-container>
<router-outlet></router-outlet>
